import { LocalPlatformAdapter, type PlatformAdapter } from "./PlatformAdapter";
import { CrazyGamesPlatformAdapter } from "./CrazyGamesPlatformAdapter";
import { GamePixPlatformAdapter } from "./GamePixPlatformAdapter";
import { YandexPlatformAdapter } from "./YandexPlatformAdapter";

/**
 * Resolves the platform adapter for a VITE_PLATFORM target. Unknown, empty and
 * absent targets fall back to the no-op LocalPlatformAdapter (canon 03 §8.4/8.8:
 * a missing platform must never break the game).
 */
export function selectPlatform(target: string | undefined): PlatformAdapter {
  switch (target) {
    case "yandex":
      return new YandexPlatformAdapter();
    case "crazygames":
      return new CrazyGamesPlatformAdapter();
    case "gamepix":
      return new GamePixPlatformAdapter();
    default:
      return new LocalPlatformAdapter();
  }
}
